import template1 from './1/component';
import template2 from './2/component';
import template3 from './3/component';
import template4 from './4/component';
import template5 from './5/component';
import template6 from './6/component';

const templates = {
	1: template1,
	2: template2,
	3: template3,
	4: template4,
	5: template5,
	6: template6,
};

export default templates;
export function InstitutionalGroup(templateId = 1) {
	return templates[templateId]();
}
